import { useState, useMemo, useCallback } from 'react';
import type { RefundView } from '../../../../../../services/RefundService';

/**
 * Search fields for filtering approvals
 */
const SEARCH_FIELDS: (keyof RefundView)[] = [
  'lastName',
  'firstName',
  'accountNumber',
  'id',
  'caseId',
  'status',
  'priority',
  'sageStatus',
];

/**
 * Hook for handling approvals search filtering
 */
export function useApprovalsSearch(items: RefundView[]) {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredItems = useMemo(() => {
    if (!searchTerm.trim()) {
      return items;
    }

    const searchLower = searchTerm.toLowerCase();
    return items.filter((item) =>
      SEARCH_FIELDS.some((field) => {
        const value = item[field];
        return value && String(value).toLowerCase().includes(searchLower);
      })
    );
  }, [items, searchTerm]);

  const handleSearchChange = useCallback((value: string) => {
    setSearchTerm(value);
  }, []);

  const handleClearSearch = useCallback(() => {
    setSearchTerm('');
  }, []);

  return {
    searchTerm,
    filteredItems,
    handleSearchChange,
    handleClearSearch,
  };
}
